import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { linkedCountText, linkedRecordCount } from '../../../../../../../../../shared/helpers/design-context';

@Component({
  standalone: false,
  selector: 'app-item-posting-summary',
  templateUrl: './item-posting-summary.component.html',
  styleUrls: ['./item-posting-summary.component.scss'],
})
export class ItemPostingSummaryComponent implements OnInit, OnDestroy {
  @Input() data: any;
  readonly linkedCountText = linkedCountText;
  /** A bid-item card groups several lines: how many carry a design context link. */
  get linkedLineItemCount(): number { return linkedRecordCount(this.data?.lineItems); }
  matchedId: any;
  matchedNo: any;
  widgetIds: any = [];
  lineItemIds: any = [];
  displayMatched: boolean;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
    if (this.data?.id) {
      this.data?.lineItems?.forEach((item) => {
        this.lineItemIds.push(item?.id);
      });
    }

    this.route.queryParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(qp => {
        if (qp && qp['matchedId']) {
          this.matchedId = qp['matchedId'];

          if (!Array.isArray(this.matchedId)) {
            this.matchedId = [this.matchedId];
          }

          if (this.matchedId?.length) {
            this.matchedId?.forEach((item) => {
              this.widgetIds?.push(item?.split('_')?.[1]);
            });
          }

          const tempData = this.matchedId?.filter((item) => {
            const parts = item?.split('_');
            return parts?.length === 3 && this.lineItemIds?.includes(parts[1]);
          });

          this.matchedNo = tempData[0]?.split('_')?.[2];
        }

        this.setDisplayMatched();
      });
  }

  setDisplayMatched() {
    if (this.lineItemIds?.length && this.widgetIds?.length) {
      const widgetSet = new Set(this.widgetIds);
      if (this.lineItemIds.find(id => widgetSet.has(id))) {
        this.displayMatched = true;
      }
    }

    this.cdRef.detectChanges();
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
